import { useSelector } from 'react-redux';

const useCheckDisabled = (checkLang: boolean, subCampaign: boolean = false): boolean => {
  const { crInfo, subCrInfo, headerLanguage } = useSelector((state: any) => ({
    crInfo: state.campaignReducer?.info,
    subCrInfo: state.subCampaignReducer?.subCampaignInfo,
    headerLanguage: state.headerReducer?.language || state.campaignReducer?.info?.defaultLanguage,
  }));

  if (!checkLang) return subCampaign ? subCrInfo?.authorization?.readOnly : crInfo?.authorization?.readOnly;

  return subCampaign
    ? (subCrInfo?.authorization?.readOnly || headerLanguage !== subCrInfo?.plantLanguage)
    : (crInfo?.authorization?.readOnly || headerLanguage !== crInfo?.defaultLanguage);
};

export default useCheckDisabled;
